$('.header__search-trigger').click(function(){
	if($(this).hasClass('icon-search')) {
		$(this).removeClass('icon-search').addClass('icon-cross');
		$('.search-bar').stop().slideDown();
	} else {
		$(this).removeClass('icon-cross').addClass('icon-search');
		$('.search-bar').stop().slideUp();
	}
});

$(window).resize(function(){
	if($(window).width() < 768) {
		$('.header__search-trigger').removeClass('icon-cross').addClass('icon-search');
		$('.search-bar').removeAttr('style');
	}
});
